export const isNullOrUndefined = (value: unknown): boolean => {
  return value === null || value === undefined;
};
